import React, { useEffect, useState, useRef } from 'react';
import 'wijmo/wijmo.touch'; // support drag/drop on touch devices
import { useMobileMediaQuery } from '../config/mediaQuery';

type Props = {
  render: () => {},
  children: any
};

const DragDropOverlay = (props: Props) => {
  const { children } = props
  const [action, setAction] = useState();
  const [draggable, setDraggable] = useState(false);
  const [isMobile, setIsMobile] = useState();

  const timerRef = useRef();
  const isLongPress = useRef();
  const draggableRef = useRef();
  const mobileResolution = useMobileMediaQuery();
  const LONG_PRESS = 'longpress';

  const touchMoveListener = (e) => {
    if (draggableRef.current === true) e.preventDefault();
  };

  const hasTouchScreenIsMobile = () => {
    let hasTouchScreen = false;
    if ('maxTouchPoints' in navigator) {
      hasTouchScreen = navigator.maxTouchPoints > 0;
    } else if ('msMaxTouchPoints' in navigator) {
      hasTouchScreen = navigator.msMaxTouchPoints > 0;
    }
    return hasTouchScreen && mobileResolution;
  };

  useEffect(() => {
    setIsMobile(hasTouchScreenIsMobile());
    document.addEventListener('touchmove', touchMoveListener, {
      passive: false,
    });
    return () => {
      document.removeEventListener('touchmove', touchMoveListener, false);
    };
  }, []);

  useEffect(() => {
    if (action === LONG_PRESS) {
      setDraggable(true);
      draggableRef.current = true;
    }
  }, [action]);

  function handleOnTouchStart(e) {
    startPressTimer();
  }

  const startPressTimer = () => {
    isLongPress.current = false;
    timerRef.current = setTimeout(() => {
      isLongPress.current = true;
      setAction(LONG_PRESS);
    }, 500);
  };

  function handleOnTouchEnd(e) {
    clearTimeout(timerRef.current);
    if (draggable) {
      setDraggable(false);
      draggableRef.current = false;
      setAction('');
    }
  }
  return (
    <div onTouchStart={isMobile ? handleOnTouchStart: null} onTouchEnd={isMobile ? handleOnTouchEnd : null}>
      {children({ draggable, isMobile })}
    </div>
  );
};

export default DragDropOverlay;
